/**
 * @param {Intl.DateTimeFormatPart[]} parts
 * @param {Intl.DateTimeFormatPartTypes} type
 */
function partValue(parts, type) {
  return parts.find((entry) => entry.type === type)?.value ?? ""
}

/**
 * Example: "Jul 4 2026, 5:46 pm PDT"
 *
 * @param {Date} date
 * @param {string} [timeZone] IANA timezone; omit for the user's local timezone
 */
function readableTimestampWithTimeZone(date, timeZone) {
  if (!(date instanceof Date) || !Number.isFinite(date.getTime())) {
    return ""
  }

  /** @type {Intl.DateTimeFormatOptions} */
  const formatOptions = {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short",
  }
  if (timeZone) {
    formatOptions.timeZone = timeZone
  }

  const parts = new Intl.DateTimeFormat("en-US", formatOptions).formatToParts(date)

  const month = partValue(parts, "month")
  const day = partValue(parts, "day")
  const year = partValue(parts, "year")
  const hour = partValue(parts, "hour")
  const minute = partValue(parts, "minute")
  const meridiem = partValue(parts, "dayPeriod").toLowerCase()
  const zoneAbbr = partValue(parts, "timeZoneName")

  if (!month || !day || !year || !hour || !minute || !meridiem) {
    return ""
  }

  return `${month} ${day} ${year}, ${hour}:${minute} ${meridiem}${zoneAbbr ? ` ${zoneAbbr}` : ""}`
}

export const formatDate = { readableTimestampWithTimeZone }
